var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.buttonClass, _vm.additionalClass],attrs:{"data-layout-item":_vm.baseLayout},on:{"click":_vm.clickButton}},[_vm._t("default",function(){return [_vm._v("\n\t\t\t"+_vm._s('contact')+"\n\t\t")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }